import process from "next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss";

export const getCreateAccountPage = async (slug) => {
    const result = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/wp/v2/pages?slug=create-account-page`, {next: {revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE)}})
    return await result.json()
}

export const createCustomerAccount = async ({data}) => {
    const url = new URL(`${process.env.NEXT_PUBLIC_API_URL}/wc/v3/customers?`)
    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };

    url.search = new URLSearchParams(params).toString();

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message)
        }
        return await response.json()
    } catch (error) {
        return {status: 400, data: {message: "Korisnik sa ovim podacima već postoji."}}
    }
}

export const resetPasswordEmail = async ({data}) => {
    const url = new URL(`${process.env.NEXT_PUBLIC_API_URL}/pzn/v1/reset-password-email`)

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message)
        }
        return await response.json()
    } catch (error) {
        return {status: 400, data: {message: error.message}}
    }
}
export const resetPassword = async ({data}) => {
    const url = new URL(`${process.env.NEXT_PUBLIC_API_URL}/pzn/v1/reset-password`)

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message)
        }
        return await response.json()
    } catch (error) {
        return {status: 400, data: {message: error.message}}
    }
}